import css from "styled-jsx/css";
import { TOP_LAYER } from "constants/z-index";

import Colors from "/styles/colors";

export const productSwitcher = css.global`
  .switcher-container {
    z-index: ${TOP_LAYER};
    margin-top: 0px;
    margin-bottom: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;

    .product-item {
      width: 98px;
      height: 150px;

      display: flex;
      flex-direction: column;
      margin-right: 22px;
      margin-left: 14px;

      .product-button {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: center;
        background-color: transparent;

        .icon-container {
          display: flex;
          align-items: flex-end;
          flex: 1;

          .product-icon {
            display: flex;
            border-radius: 12px;
            width: 64px;
            height: 64px;
            justify-content: center;
            align-items: center;
            transition: transform 0.1s;
            background-color: var(--switcher-color);
            &.is-selected-product {
              width: 86px;
              height: 86px;
              svg {
                width: 62px;
                height: 62px;
              }
            }
          }
        }

        .icon-container:hover {
          transition-timing-function: ease-in;
          transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
          transform: scale3d(1.05, 1.05, 1);
          &.is-selected-product {
            transition: none;
            transform: none;
          }
        }

        .product-label {
          padding-top: 16px;
          color: ${Colors["asphalt"]};
          height: 30%;
          font-size: 16px;
          &.is-selected-product {
            font-weight: 600;
            color: ${Colors["mud"]};
          }
        }
        svg {
          width: 42px;
          height: 42px;
        }
      }
      .tooltip {
        border-radius: 4px;
        opacity: 0;
        display: none;
        z-index: ${TOP_LAYER};
        top: 100%;
        left: 100%;
        transform: translate(-50%);
        margin-top: 8px;

        :global(.floating-tooltip) {
          white-space: normal;
          padding: 16px;
          width: 272px;
          line-height: 20px;
        }
      }
      .tooltip:after {
        visibility: visible;
        opacity: 1;
        z-index: ${TOP_LAYER};
        bottom: 100%;
        rotate: 180deg;
        left: 38%;
        transform: translate(-100%);
      }
    }

    .product-item:hover {
      .tooltip {
        display: block;
        opacity: 1;
      }
    }

    button {
      border: none;
    }
  }
`;
